"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTag = exports.Title = exports.Box = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Box = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${colors_1.PALE_GREEN};
  padding: 8px 16px;
`;
exports.Title = styled_components_1.default.h2 `
  color: ${colors_1.GREY4};
  text-align: center;
  margin: 4px 0;
  font-size: 16px;
  font-weight: 400;
`;
exports.MessageTag = styled_components_1.default.span `
  cursor: pointer;

  & abbr span {
    font-size: 16px;
    font-weight: bold;
  }
`;
//# sourceMappingURL=SoundBox.styles.js.map